<template>
  <section class="price">
    <div class="container">
      <a-typography-title :level="1">
        各版本功能及定价
      </a-typography-title>
      <a-table tableLayout="fixed"
               :columns="table.column" :data-source="table.data"
               :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?'default':'small'" :pagination="false"
               :row-class-name="(record,index)=>(index%2===1?'table_color':null)">
        <template #bodyCell="{column,value}">
          <template v-if="column.key==='name'">
            <b>{{ value }}</b>
          </template>
          <template v-if="['base','specialty','enterprise'].indexOf(column.key)>=0">
            <template v-if="typeof value==='boolean'">
              <CheckOutlined v-if="value" :style="{color:$Enum.ColorEnum.Success,fontSize:'18px'}" />
              <CloseOutlined v-else :style="{color:'#aaaaaa'}" />
            </template>
            <template v-else>
              {{ value }}
            </template>
          </template>
        </template>
      </a-table>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3"
                  @click="$RQ.GoGSS()">
          免费试用
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'product_price',
  components: {
    CheckOutlined,
    CloseOutlined
  },
  data(): DataInterface {
    return {
      table: {
        column: [
          {
            key: 'name',
            dataIndex: 'name',
            title: '对比项',
            width: 50
          },
          {
            key: 'base',
            dataIndex: 'base',
            title: '基础版',
            width: 50,
            align: 'center'
          },
          {
            key: 'specialty',
            dataIndex: 'specialty',
            title: '专业版',
            width: 50,
            align: 'center'
          },
          {
            key: 'enterprise',
            dataIndex: 'enterprise',
            title: '企业版',
            width: 50,
            align: 'center'
          }
        ],
        data: [
          {
            name: '云账号数量限制',
            base: '10',
            specialty: '无限制',
            enterprise: '无限制'
          },
          {
            name: '应用数量限制',
            base: '500',
            specialty: '无限制',
            enterprise: '无限制'
          },
          {
            name: '完善的技术文档支持',
            base: true,
            specialty: true,
            enterprise: true
          },
          {
            name: '5*8小时远程技术支持',
            base: true,
            specialty: true,
            enterprise: true
          },
          {
            name: '定制化优化方案及功能',
            base: false,
            specialty: false,
            enterprise: true
          },
          {
            name: '30天免费试用',
            base: true,
            specialty: false,
            enterprise: false
          },
          {
            name: '费用',
            base: '9800元/月',
            specialty: '16800元/月',
            enterprise: '325000元/年起'
          }
        ]
      }
    };
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.price {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-table-wrapper {
  margin: @margin 0 0;
  
  &:deep(.ant-table-container) {
    .ant-table-thead {
      .ant-table-cell {
        .font(center, @text_big, @color_white, @text_big, true);
        background: @color_6;
        
        &::before {
          background-color: @color_white !important;
        }
      }
    }
    
    .ant-table-cell {
      white-space: pre-line;
      font-size: @text;
      
      &.ant-table-cell-row-hover {
        background-color: fade(@color_6, 8);
      }
    }
    
    .table_color {
      background-color: fade(@color_6, 3);
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .price {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
    
    &::before {
      display: none;
    }
  }
  
  .ant-table-wrapper {
    margin: @margin_mo 0 0;
    
    &:deep(.ant-table-container) {
      .ant-table-thead {
        .ant-table-cell {
          .font(center, @text_big_mo+@line_mo, @color_white, @text_big_mo, true);
        }
      }
      
      .ant-table-cell {
        padding-left: 0;
        padding-right: 0;
        font-size: @font_7;
      }
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>